// extracted by mini-css-extract-plugin
module.exports = {"honeypotWrapper":"FHREF"};